// @ts-strict-ignore
import { web } from "@hubble/tokens";
import { Flex, Input, mediaQuery } from "@hubble/web";
import styled from "styled-components";

export const PriceConverterFormContainer = styled.section`
  margin-top: 1rem;
`;

export const PriceConverterFormConversionDateContainer = styled.div`
  margin-top: 4.5rem;

  @media ${mediaQuery.mobileXsDown} {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
`;

// Styled components for ConverterForm.tsx
export const ConverterFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin: 4.5rem auto;

  @media ${mediaQuery.mobileXsDown} {
    margin: 1.5rem auto;
  }
`;

export const InputGroup = styled(Flex)`
  align-items: center;
  flex-direction: row;
  gap: 22px;
  width: 100%;

  @media ${mediaQuery.tabletSmDown} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StyledInput = styled(Input)`
  flex: 1;
  input {
    font-size: 32px;
    font-weight: 600;
    line-height: 40px;
    text-align: right;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      margin-left: 3px;
      position: relative;
      transform: scaleX(0.7);
    }

    @media ${mediaQuery.mobileXsDown} {
      font-size: 24px;
      font-weight: 700;
      line-height: 32px;
      text-align: right;
    }
  }
` as typeof Input;

export const ButtonIconContainer = styled.div`
  height: 24px;
  width: 24px;
  background-color: ${web.color.base.gray[50]};
  border-radius: 50%;
`;
